import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2ad983ac"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "offerModal" }
const _hoisted_2 = { class: "modalHeaderWrapper" }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "is-flex-grow-1" }, null, -1))
const _hoisted_5 = { class: "modalContentWrapper" }
const _hoisted_6 = { class: "modalLeftColumn" }
const _hoisted_7 = { class: "offerName" }
const _hoisted_8 = { class: "partnerName mt-2" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" by ")
const _hoisted_10 = ["href"]
const _hoisted_11 = { key: 1 }
const _hoisted_12 = {
  key: 0,
  class: "pt-1 font-bold"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-map-pin mr-2" }, null, -1))
const _hoisted_14 = ["href"]
const _hoisted_15 = { key: 1 }
const _hoisted_16 = ["innerHTML"]
const _hoisted_17 = {
  key: 1,
  class: "mt-3"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "inline mr-2" }, "Helps With:", -1))
const _hoisted_19 = {
  key: 2,
  class: "mt-3"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "inline mr-2" }, "Serving:", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modalHorizontalSpacer" }, null, -1))
const _hoisted_22 = { class: "modalRightColumn" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "To be eligible for this program, you must meet the following requirements:", -1))
const _hoisted_24 = ["innerHTML"]
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "is-flex-grow-1" }, null, -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "nextSteps mt-5" }, "Next Steps", -1))
const _hoisted_27 = ["innerHTML"]

import { computed, ref } from 'vue';
import { PartnerOffer } from '@/features/partnerOffers/model';
import OfferTag from './OfferTag.vue';
import { logInteraction } from './api';
import { InteractionType } from '@/features/analytics/api';


export default /*#__PURE__*/_defineComponent({
  __name: 'OfferModal',
  props: {
    offer: null,
    context: null
  },
  emits: ["closed"],
  setup(__props: any, { emit }: { emit: ({
    (e: 'closed'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  offer: PartnerOffer,
  context: string,
}



const servingTags = computed(()=>props.offer.tags.filter(t=>t.id.startsWith("serving::")));
const categoryTags = computed(()=>props.offer.tags.filter(t=>t.id.startsWith("category::")));

const didApply = ref<boolean>(false);



const handleBackdropClick = (e: any) => {
  if (e.target.className === 'modal-backdrop') {
    closeClicked();
  }
};

const applyClicked = () => {
  didApply.value = true;
  logInteraction(props.context, props.offer, InteractionType.PROGRESS, "applyClicked");
  window.open(props.offer.applyLink, "_blank");
}

const closeClicked = () => {
  if (!didApply.value) {
    logInteraction(props.context, props.offer, InteractionType.CANCELLATION, "closeClicked");
  }
  emit('closed');
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "modal-backdrop",
    onClick: handleBackdropClick
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("img", {
          class: "partnerLogo",
          src: __props.offer.partner.logoImage || '/img/partner_logo_placeholder.png'
        }, null, 8, _hoisted_3),
        _hoisted_4,
        _createElementVNode("i", {
          class: "fas fa-times modalCloseButton",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (closeClicked()))
        })
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("h1", _hoisted_7, _toDisplayString(__props.offer.name), 1),
          _createElementVNode("h2", _hoisted_8, [
            _hoisted_9,
            (__props.offer.partner.website)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  href: __props.offer.partner.website,
                  target: "_blank"
                }, _toDisplayString(__props.offer.partner.name), 9, _hoisted_10))
              : (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(__props.offer.partner.name), 1))
          ]),
          (__props.offer.partner.address)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _hoisted_13,
                _createElementVNode("strong", null, [
                  (__props.offer.partner.addressLink)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        href: __props.offer.partner.addressLink,
                        target: "_blank"
                      }, _toDisplayString(__props.offer.partner.address), 9, _hoisted_14))
                    : (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(__props.offer.partner.address), 1))
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: "pt-4 pb-2 text-md text-secondary-300 modalTextContent",
            innerHTML: __props.offer.moreInfo || __props.offer.description
          }, null, 8, _hoisted_16),
          (_unref(categoryTags).length != 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                _hoisted_18,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(categoryTags), (tag) => {
                  return (_openBlock(), _createBlock(OfferTag, {
                    tag: tag,
                    type: "CATEGORY",
                    key: tag.id
                  }, null, 8, ["tag"]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (_unref(servingTags).length != 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                _hoisted_20,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(servingTags), (tag) => {
                  return (_openBlock(), _createBlock(OfferTag, {
                    tag: tag,
                    type: "SERVING",
                    key: tag.id
                  }, null, 8, ["tag"]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ]),
        _hoisted_21,
        _createElementVNode("div", _hoisted_22, [
          _hoisted_23,
          _createElementVNode("div", {
            class: "mt-2 text-secondary-300 modalTextContent",
            innerHTML: __props.offer.eligibility
          }, null, 8, _hoisted_24),
          _hoisted_25,
          _hoisted_26,
          _createElementVNode("div", {
            class: "mt-2 text-secondary-300 modalTextContent",
            innerHTML: __props.offer.nextSteps
          }, null, 8, _hoisted_27),
          (__props.offer.applyLink)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                onClick: _cache[1] || (_cache[1] = ($event: any) => (applyClicked())),
                class: "modalApplyButton mt-4"
              }, _toDisplayString(__props.offer.applyLabel ? __props.offer.applyLabel.toUpperCase() : 'APPLY NOW'), 1))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}
}

})